import { RootState } from 'store';

export const interceptionsSelector = (state: RootState) =>
  state.interceptions.interceptions;
export const interceptionMembersSelector = (state: RootState) =>
  state.interceptions.members;
export const interceptionNetworksSelector = (state: RootState) =>
  state.interceptions.networks;
export const interceptionTranscriptsSelector = (state: RootState) =>
  state.interceptions.currentTranscripts;
export const interceptionDepartmentsSelector = (state: RootState) =>
  state.interceptions.departments;
